module.exports = __webpack_public_path__ + "img/SSA5.ff0650da.png";